/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { Table, Alert, Tag, Button } from "antd";
import { ClearOutlined, FileExcelOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";

import { HeaderForm } from "./HeaderForm";
import { Spinner } from "../../components/spinner/Spinner";
import { removeDuplicates, formatDateTime } from "../../utils/utils";

import {
  useFetchOrders,
  useFilteredOrders,
  useFetchOrdersBy,
  useFilters,
} from "../../app/orders/mutations";

import { columns } from "./constants";

import "../../styles/orders/ordenes.scss";
import useState from "react-usestateref";

export const Traceability = () => {
  const _useFilteredOrders = useFilteredOrders();
  const { selectedFilters, removeFilter, resetFilters } =
    useFilters();
    const [isLoading, setIsLoading] = useState(false);
    const [queryParams, setQueryParams] = useState({});
  
    
  let {
    isFetching,
    isError,
    error,
    orders,
    refetch,
  } = useFetchOrders(queryParams);

  let key =
    _useFilteredOrders.length === 0
      ? orders
      : _useFilteredOrders !== -1
      ? _useFilteredOrders
      : [];

  const handleSubmit = async (queries) => {
    setIsLoading(true);
    setQueryParams(queries);
    resetFilters();
    setTimeout(() => {
      refetch().finally(() => setIsLoading(false));
    }, 500);
  };

  if (isError && error instanceof Error)
    return (
      <Alert
        message="Ocurrión un error"
        description={error.message}
        type="error"
        showIcon
      />
    );

  const clientsDocuments =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.cedula))
      : [];

  const clientsOrders =
    orders && orders.length > 0
      ? removeDuplicates(orders.map((order) => order.codigoPedido))
      : [];

  const STATUSES_FILTER = removeDuplicates(key.map((o) => o.estado)).map(
    (o) => {
      return {
        value: o.toUpperCase(),
        label: o.toUpperCase(),
      };
    }
  );

  const handleFilterClose = (filter) => {
    removeFilter(filter);
    useFetchOrdersBy();
  };

  const handleFilterReset = () => {
    resetFilters();
    useFetchOrdersBy();
  };

  const handleDownload = () => {
    const data = JSON.parse(JSON.stringify(orders));

    // create workbook and worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(data);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Ordenes");
    // customize header names
    XLSX.utils.sheet_add_aoa(worksheet, [
      [
        "Codigo Pedido",
        "Codigo Cliente",
        "Cliente",
        "Codigo Punto de Venta",
        "Punto de Venta",
        "Solicitante",
        "Producto",
        "Codigo EAN",
        "Descripcion",
        "Cantidad",
        "Factura Cliente",
        "Tipo Pedido",
        "Precio Total",
        "Fecha Pedido",
        "Fecha Promesa",
        "Fecha Envio",
        "Fecha Entrega",
        "Fecha Despacho",
        "Fecha Creación", 
        "Observaciones",
        "Estado",
        "Ultimo Evento",
        "Causa",
        "Nota Transporte",
        "Camion",
        "Numero Guia",
        "Cedula Subcliente",
        "Nombre Subcliente",
        "Telefono 1 Subcliente",
        "Telefono 2 Subcliente",
        "Direccion Subcliente",
        "Barrio Subcliente",
        "Codigo Municipio",
        "Municipio Subcliente",
        "Departamento", 
        "Tirilla",
        "Transportista",
        "Referencia",
        "Ultima Llamada"
      ],
    ]);

    XLSX.writeFile(workbook, `pedidos_${formatDateTime()}.xlsx`, {
      compression: true,
    });
  };

  return (
    <>
      <div className="orders">
        <div className="orders-header">
          <h2>Consulta Trazabilidad</h2>
        </div>
        <div className="orders-form">
          <HeaderForm
            onSubmit={handleSubmit}
            disabled={orders.length === 0 ? true : false}
            ordersIds={clientsOrders}
            documentsIds={clientsDocuments}
            statuses={STATUSES_FILTER}
            isLoading={isLoading || isFetching}
          />
        </div>

        <div className="orders-filters">
          {selectedFilters && selectedFilters.length > 0 && (
            <Button
              id="clear-filters-btn"
              type="link"
              icon={<ClearOutlined />}
              onClick={handleFilterReset}
            >
              Limpiar Filtros
            </Button>
          )}

          {selectedFilters &&
            selectedFilters.length > 0 &&
            selectedFilters.map((filter, index) => (
              <Tag
                closable
                key={index}
                onClose={() => handleFilterClose(filter)}
              >
                {filter.label}: <b>{filter.value}</b>
              </Tag>
            ))}
        </div>

        <div className="orders-table">
          <Button
            form="orderDetailForm"
            key="submit"
            type="default"
            className="btn-primary"
            style={{ marginBottom: 10 }}
            onClick={handleDownload}
            disabled={!(orders.length > 0)}
          >
            <FileExcelOutlined /> Descargar Excel
          </Button>
          <div className="orders-table-content">
            {isFetching && <Spinner tip="Cargando, por favor espere..." />}
            {!isFetching && (
              <Table
                columns={columns}
                dataSource={key}
                locale={{ emptyText: "No hay datos correspondientes" }}
                scroll={{ x: 800 }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
